import React, { useEffect } from 'react';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
// import { fromTokenFile } from "@aws-sdk/credential-providers";

const AuthInitializer = () => {
  // localStorage.clear();
  // sessionStorage.clear();
  useEffect(() => {
    const fetchAndLogUser = async () => {
      try {
        const { username, userId, signInDetails } = await getCurrentUser();
        console.log("username>>", username);
        console.log("user id>>", userId);
        console.log("sign-in details>>", signInDetails);

        const tk = await fetchAuthSession();
        console.log("tk", tk);
      } catch (error) {
        console.error("Error fetching user in AuthInitializer:", error);
      }
    };

    fetchAndLogUser();
  }, []); // Empty dependency array means this runs once on mount

  return null; // This component doesn't render anything itself
};

export default AuthInitializer;